import React, { useEffect, useState } from 'react'
import { IIncentiveList } from './Table'
import { Dialog } from 'primereact/dialog'
import { Fetch } from '../../shared/Fetch'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
interface IProps {
    singleData: IIncentiveList,
    open: boolean,
    hideDialog: () => void,

}

interface IIncentiveConsultantDetail {
    PO_ID?: number,
    referal?: string,
    consultant_Name?: string,
    branchName?: string,
    company_Name?: string,
    hours_MRate?: number,
    inHouseUser?: string,
    incPer?: number,
    invoiceHours?: number,
    mRate?: number,
    rate_By_Percentage?: number,
    paymentStatus?: string,
    sub_Vendor_Company?: string,
    vendor_Company_Name?: string,
    totalAmountInRupee?: number
}
export const IncentiveConsultantDetail = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: IIncentiveConsultantDetail[], loading: boolean })

    const onHide = () => {
        props.hideDialog();
    }

    const loadIncentiveConsultantDetails = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("vwPODetails/incentiveConsultantDetail", "GET", null, `user_Id=${props.singleData?.user_ID}`, null);
        if (response) {
            const data = await response.json();
            console.log(data);
            setTableData({ tableData: data, loading: false })
        }
    }
    useEffect(() => {
        if (props.open) {
            loadIncentiveConsultantDetails()
        }
    }, [props.open])

    return (
        <Dialog visible={props.open} header="Incentive Consultant Detail" style={{ width: '80vw' }} modal className="p-fluid" onHide={onHide}>
            <DataTable value={tableData.tableData} size="small" stripedRows showGridlines>
                <Column field='referal' header="Referal" />
                <Column field='consultant_Name' header="Consultant Name" />
                <Column field='inHouseUser' header="In House User" />
                <Column field='company_Name' header="Company" />
                <Column field='branchName' header="Branch" />
                <Column field='vendor_Company_Name' header="Vendor Company" />
                <Column field='sub_Vendor_Company' header="Sub Vendor Company" />
                <Column field='mRate' header="MRate" />
                <Column field='incPer' header="Inc Per" />
                <Column field='invoiceHours' header="Invoice Hours" />
                <Column field='hours_MRate' header=" Hours MRate" />
                <Column field='rate_By_Percentage' header="Rate By Percentage" />
                <Column field='totalAmountInRupee' header="TotalAmountInRupee" />
                <Column field='paymentStatus' header="Payment Status" />
            </DataTable>
        </Dialog>

    )
}
